import { Component, Input, ViewChild, ElementRef } from '@angular/core';

import { Rodeo } from '../../../../model/rodeo';
import { RodeoEventRun } from '../../../../model/rodeoEventRun';
import { RunService } from '../../../../services/run.service';
import { LoadingController, ToastController, ViewController } from 'ionic-angular';
import { ImageService } from '../../../../services/image.service';
import { RunsConfig } from 'model/runsConfig';

@Component({
    selector: 'staff-video-upload',
    templateUrl: 'video-upload.html'
})
export class VideoUploadSection {
    @ViewChild('runContainer') runContainer: ElementRef;
    _rodeo: Rodeo;

    startedTimers: boolean;
    stopTimers: boolean;

    popoverActive: boolean;

    allRuns: boolean;
    missingVideos: boolean;
    ignoreNoTimes: boolean;
    runCount: number = 0;

    loggedRuns: RodeoEventRun[] = [];

    eventTypeMapping: Map<any, any> = new Map();
    nameMapping: Map<any, any> = new Map();

    @Input()
    set rodeo(rodeo: Rodeo) {
        if (rodeo != null) {
            this._rodeo = rodeo;

            this._rodeo.rodeoEvents.forEach((rodeoEvent) => {
                if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding'
                || rodeoEvent.eventType === 'BarebackRiding')
                    rodeoEvent.roughStock = true;

                rodeoEvent.schedules.forEach(schedule => {
                    this.eventTypeMapping[schedule.id] = rodeoEvent.eventType;
                    this.nameMapping[schedule.id] = rodeoEvent.displayName;
                });
            });
        }
    }
    get rodeo(): Rodeo {
        return this._rodeo;
    }

    constructor(private runService: RunService, private toast: ToastController, private viewController: ViewController, private loader: LoadingController, private imageService: ImageService) { }

    startTimers() {
        if (this.startedTimers)
            return;

        this.getUpdatedRuns();
        this.startedTimers = true;
    }

    stopTimerLoops() {
        this.stopTimers = true;
    }

    updateRunCount() {
        let runs = [];

        if (this.allRuns)
            runs = this.rodeo.rodeoEvents.flatMap(x => x.schedules).flatMap(x => x.runs);
        else 
            runs = this.loggedRuns;
        
        if (this.missingVideos)
            runs = runs.filter(x => x.done && (!x.videos || x.videos.length == 0));

        if (this.ignoreNoTimes)
            runs = runs.filter(x => !x.noTime && !x.turnedOut);

        this.runCount = runs.length;
    }

    copySelectedRunUrlToClip() {
        window.navigator['clipboard'].writeText("https://nextgenrodeo-services-client.azurewebsites.net/timer/getSelectedRun?rodeoId=" + this.rodeo.id);
    }

    copyJudgeUrlToClip() {
        window.navigator['clipboard'].writeText("https://nextgenrodeo-services-client.azurewebsites.net/timer/getSelectedRunJudgeScores?rodeoId=" + this.rodeo.id);
    }

    copySplitsUrlToClip() {
        window.navigator['clipboard'].writeText("https://nextgenrodeo-services-client.azurewebsites.net/timer/getSelectedRunSplits?rodeoId=" + this.rodeo.id);
    }

    getUpdatedRuns() {
        let runUpdateInfo = [];

        this.loggedRuns.forEach((run) => {
            runUpdateInfo.push({ Id: run.id, Updated: run.updated });
        });

        this.runService.getCompletedEventRuns(this.rodeo.id, runUpdateInfo)
        .then (data => {
            (data as any).update.forEach(run => {                
                for (let y = 0; y < this.loggedRuns.length; y++) {
                    if (this.loggedRuns[y].id == run.id) {
                        this.setDisplayValue(run);
                        Object.assign(this.loggedRuns[y], run);  
                    }
                }             
            });

            (data as any).delete.forEach(run => {
                this.loggedRuns = this.loggedRuns.filter(x => x.id != run.id);             
            });

            (data as any).add.forEach(run => {
                this.setDisplayValue(run);
                this.loggedRuns.push(run);
            });

            this.loggedRuns.sort((a, b) => {
                if (a.updated > b.updated)
                    return -1;
                else if (a.updated < b.updated)
                    return 1;
                else 
                    return 0;
            });

            this.updateRunCount();

            this.refreshUpdateRuns();
        }, error => {
            this.refreshUpdateRuns();
        });
    }

    refreshUpdateRuns() {
        setTimeout(() => {
            if (this.viewController.isLast())
                this.getUpdatedRuns();
        }, 100);
    }

    async fileChange(fileList, run: RodeoEventRun) {
        if (fileList && fileList.length > 0) {
            let videoToUpload = fileList.item(0);

            const loader = this.loader.create({content: 'Uploading Video...'});
            await loader.present();
            
            const filename = run.id.toString() + '.' + videoToUpload.name.split('.').pop();

            try
            {
                await this.imageService.uploadRunVideo(videoToUpload, run.id, filename);

                await this.toast.create({
                    message: 'Video Uploaded Successfully!',
                    showCloseButton: true,
                    duration: 3000
                }).present();
            }
            catch (err)
            {
                console.log('Video upload issue: ', err);
            }
            
            await loader.dismiss();
        }
    }

    isRoughStock(eventType) {
        if (eventType === 'BullRiding' || eventType === 'SaddleBroncRiding' || eventType === 'RanchBroncRiding' || eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    getFirstLabel(run : RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        switch (eventType) {
            case 'TeamRoping':
                return 'Header';
            default:
                return 'Rider';            
        }
    }

    getSecondDisplay(run : RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];

        switch (eventType) {
            case 'TeamRoping':
                return run.contestantTwo.firstName + ' ' + run.contestantTwo.lastName;
            case 'BarrelRacing':
                if (run.horseOne == null)
                    return "Horse 1";
                else
                    return run.horseOne.name;            
            default:
                if (run.livestock == null)
                    return "Livestock 1";
                else
                    return run.livestock.brand + ' ' + run.livestock.name;
        }
    }

    getSecondLabel(run : RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        switch (eventType) {
            case 'TeamRoping':
                return 'Heeler';
            case 'BarrelRacing':
                return 'Horse';            
            default:
                return "Livestock";
        }
    }

    getRunValue(run : RodeoEventRun, total: boolean = false) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        if (!total)
        {
            if (run.noTime)
                return this.isRoughStock(eventType) ? "NS" : "NT";

            if (run.turnedOut)
                return "TO";
        }

        let extraOnDisplay = ' on ' + run.displaySuccessfulRuns;

        if (this.isRoughStock(eventType)) {
            if (run.done)
                return !total ? run.score : run.totalScore + extraOnDisplay;
            else
                return run.score;
        }
        else
        {
            var timeString = "";

            if (run.done)
                timeString = (!total ? run.time : run.totalTime).toString();
            else
                timeString = run.time.toString();

            var periodIndex = timeString.indexOf(".");

            if (periodIndex == -1)
                timeString += ".";

            let zeroCount = timeString.length - 1 - timeString.indexOf(".");
            let decimalPlaces = 3;

            if (eventType.indexOf('Barrel') == -1)
                decimalPlaces--;

            if (eventType.indexOf('Wrestling') != -1)
                decimalPlaces--;

            while (decimalPlaces - zeroCount > 0) {
                timeString += "0";
                zeroCount++;
            }

            if (zeroCount > decimalPlaces) {
                timeString = timeString.toString().substring(0, periodIndex + 3);
            }

            if (run.done && total)
                timeString += extraOnDisplay;

            return timeString;
        }
    }

    setDisplayValue(run: RodeoEventRun) {
        let eventType = this.eventTypeMapping[run.rodeoEventScheduleId];
        
        if (!run)
            return;

        if (run.noTime)
            run.displayValue = this.isRoughStock(eventType) ? "NS" : "NT";
        else {
            if (this.isRoughStock(eventType)) {
                 run.displayValue = run.score;
            } else {
                var timeString = run.time.toString();
                var periodIndex = timeString.indexOf(".");
    
                if (periodIndex == -1)
                    timeString += ".";
    
                let zeroCount = timeString.length - 1 - timeString.indexOf(".");
                let decimalPlaces = 3;
    
                if (eventType.indexOf('Barrel') == -1)
                    decimalPlaces--;
    
                if (eventType.indexOf('Wrestling') != -1)
                    decimalPlaces--;
    
                while (decimalPlaces - zeroCount > 0) {
                    timeString += "0";
                    zeroCount++;
                }

                if (zeroCount > decimalPlaces) {
                    timeString = timeString.toString().substring(0, periodIndex + 3);
                }

                run.displayValue = timeString;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/videos/video-upload.ts